import TableAdvanceSearch from './components/table-ag-advance-search';
import TableAGButtonActions from './components/table-ag-button-actions';
import TableSortAction from './components/table-ag-sort';
import { TableAGSwitch } from './components/table-ag-switch';
import TableFilterAction from './components/table-filter-action';
import TablePagination from './components/table-pagination';
import TableAGComponent from './table-ag';
import { actionCol, checkBoxCol } from './table-ag-constants';
import TableAGV2 from './table-ag-v2';
import { useTableAG } from './use-table-ag';

const TableAG = {
    /**Component table root */
    Root: TableAGComponent,
    /**Table AG with callback API */
    TableAGV2: TableAGV2,
    /**Table Pagination */
    TablePagination: TablePagination,
    /**Table filter action */
    TableFilterAction: TableFilterAction,
    /**Table sort */
    TableSortAction: TableSortAction,
    /**Button actions using in table */
    ButtonActions: TableAGButtonActions,
    /**Active switch custom on table */
    ActiveSwitch: TableAGSwitch,
    /**Checkbox columnDef */
    CheckBoxCol: checkBoxCol as any,
    /**Action col */
    ActionCol: actionCol,
    /**Table AdvanceSearch */
    TableAdvanceSearch: TableAdvanceSearch,
    /**hooks */
    useTableAG: useTableAG,
    /**name component */
    name: 'Table AG Custom',
};

export type { TableButtonActionsProps } from './components/table-ag-button-actions';
export * from './table-ag-constants';
export * from './table-ag-types';
export * from './table-ag-utils';
export * from './table-ag-v2';
export default TableAG;
